import { ConsigneeAddressType } from "pages/shipper/RequestFormV2/defaults/consigneeDefaults";
import { ScheduleStopValue } from "pages/shipper/RequestFormV2/defaults/scheduleDefaults";
import { StopAddressType } from "types/MultiStop";

export const DELIVERY_STOP_INDEX = 1;

export function stopAddressTypeToConsigneeString(stopType: StopAddressType): ConsigneeAddressType {
  switch (stopType) {
    case StopAddressType.AIRPORT:
      return "airport";
    case StopAddressType.SEAPORT:
      return "seaport";
    default:
      return "address";
  }
}

export function mapDeliveryStopToConsignee(stop: ScheduleStopValue) {
  return {
    address_type: stopAddressTypeToConsigneeString(stop.stop_address_type),
    address_id: stop.address_id,
    address_reference_number: stop.address_reference_number ?? "",
    address_name: stop.address_name ?? "",
    address_street: stop.street_address ?? "",
    address_street_line2: stop.street_address_line_two ?? "",
    address_city: stop.city_name ?? "",
    address_state: stop.state_name ?? "",
    address_country: stop.country_name ?? "",
    address_zipcode: stop.zipcode ?? "",
    contact_name: stop.stop_contact_name ?? "",
    contact_phone: stop.stop_contact_number ?? "",
    contact_email: stop.stop_contact_email ?? "",
    airport: stop.stop_airport_code ?? "",
    airport_name: stop.stop_airport_name ?? "",
    seaport: stop.stop_seaport_code ?? "",
    seaport_name: stop.stop_seaport_name ?? "",
    form_address_contact_type: "delivery" as const,
  };
}
